import styled, { keyframes } from 'styled-components';
import { colors, fontFamily } from '../../../Utils/tokens';

export const Actions = styled.div<{ $visible: boolean }>`
  display: flex;
  align-items: center;
  gap: 2px;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.15s ease;

  &:focus-within {
    opacity: 1;
  }
`;

/** "Chat AI / Chat / AI Answer" */
export const AnswerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;

  &:hover ${Actions} {
    opacity: 1;
  }
`;

const shimmer = keyframes`
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
`;

/** "AiAnalysisContainer": exibido até chegar o primeiro trecho da resposta. */
export const Analysis = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 24px;

  img {
    width: 12px;
    height: 12px;
  }

  span {
    font-family: ${fontFamily};
    font-size: 12px;
    font-weight: 600;
    line-height: 1.5;
    background: linear-gradient(
      90deg,
      ${colors.onSurfaceVariant} 0%,
      ${colors.onSurfacePlaceholder} 50%,
      ${colors.onSurfaceVariant} 100%
    );
    background-size: 200% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    animation: ${shimmer} 2s linear infinite;
  }
`;

export const ErrorText = styled.p`
  margin: 0;
  font-family: ${fontFamily};
  font-size: 12px;
  line-height: 1.5;
  color: ${colors.danger};
`;

export const FeedbackForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  width: 100%;
  margin-top: 4px;

  textarea {
    width: 100%;
    min-height: 72px;
    padding: 8px 10px;
    border: 1px solid transparent;
    border-radius: 6px;
    outline: none;
    background-color: ${colors.secondary};
    font-family: ${fontFamily};
    font-size: 12px;
    line-height: 16px;
    color: ${colors.onSurface};
    resize: vertical;

    &::placeholder {
      color: ${colors.onSurfacePlaceholder};
    }

    &:focus {
      border-color: ${colors.primary};
      background-color: ${colors.surface};
    }
  }
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  background-color: ${colors.primary};
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${colors.onPrimary};
  cursor: pointer;

  &:disabled {
    box-shadow: inset 0 0 0 1px ${colors.onSurfacePlaceholder};
    background-color: ${colors.surfaceOutline};
    color: ${colors.onSurfacePlaceholder};
    cursor: default;
  }
`;
